import React from "react";
import FormGroupCustom from "./FormGroupCustom";
import {FormElementsModel} from "./models/FormModule";


export const FormElements = ({
                                 structure,
                                 dataForm,
                                 isSubmit,
                                 changeValue,
                                 rightTemplate,
                                 style,
                                 errors
                             }: FormElementsModel) => {
    return (
        <div className="row" style={style}>
            {structure.map((ele: any) => (
                <FormGroupCustom
                    key={ele.name}
                    structure={ele}
                    isSubmit={isSubmit}
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                />
            ))}
            {rightTemplate && rightTemplate}
        </div>
    );
};
